<template>
  <div id="app">
    <router-view ref="content" v-if="isRouterAlive" />
    <global-msg></global-msg>
  </div>
</template>

<script>
import { getByReferer } from '@/requests/user' // 用户信息修改
import GlobalMsg from '_c/modals/globalMsg'
import { Message } from 'view-design';
window.$msg = Message;
export default {
  name: 'app',
  components: {
    GlobalMsg,
  },
  data () {
    return {
      isRouterAlive: true,
    }
  },
  mounted () {
    window.routerReload = () => {
      this.reload()
    }
    this.$domFn.addListen(window, 'beforeunload', (e) => {
      /* eslint-disable */
      var e = window.event || e
      // e.returnValue = ("确定离开当前页面吗？")
    })
    this.$WhdsRemoteProtocal.runHeart()
    this.$nextTick(() => {
      window.$APP.$store.state.plugin.remotingItems = this.$WhdsRemoteProtocal.remotingItems
    })
    this.getByReferer()
    //监听键盘按键事件
    this.$nextTick(function () {
      document.addEventListener('keyup', function (e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27)
        {
          window.$Message.hide()
        }
      })
    })
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    async getByReferer () {
      let res = await getByReferer()
      if (res.code == 200)
      {
        if (!res.data)
        {
          // document.title = this.$Cookie.getCookie('webTitle')
          //   ? this.$Cookie.getCookie('webTitle')
          //   : '维护大师远程管理平台'
        } else
        {
          document.title = res.data.webTitle
          if (this.$Cookie.getCookie('beforeLoginLogo'))
          {
            this.$Cookie.delCookie('beforeLoginLogo')
          }
          if (this.$Cookie.getCookie('afterLoginLogo'))
          {
            this.$Cookie.delCookie('afterLoginLogo')
          }
          this.$Cookie.setCookie('beforeLoginLogo', res.data.beforeLoginLogo)
          this.$Cookie.setCookie('afterLoginLogo', res.data.afterLoginLogo)
        }
      }
    },
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
